import * as React from 'react'
import {ModGridRow} from 'components/layout/ModGridRow'
import {FormattedMessage} from 'react-intl'

export interface SearchTemplateProps {
  currentLanguage?: string
}

declare global {
  interface Window {
    __gcse?: any
    google?: any
    Cookiebot?: any
  }
}

export function SearchTemplate({currentLanguage}: SearchTemplateProps) {
  const [recheckCookie, setRecheckCookie] = React.useState(false)
  const [canShowSearch, setCanShowSearch] = React.useState(false)

  React.useEffect(() => {
    if (typeof window === 'undefined') return

    const trigger = () => setRecheckCookie(v => !v)

    const updateVisibility = () => {
      // @ts-ignore
      if (typeof Cookiebot !== 'undefined' && Cookiebot.consent && Cookiebot.consent.marketing) {
        setCanShowSearch(true)
      } else {
        setCanShowSearch(false)
      }
    }

    window.addEventListener('CookiebotOnLoad', () => {
      updateVisibility()
      trigger()
    })
    window.addEventListener('CookiebotOnAccept', () => {
      updateVisibility()
      trigger()
    })
    window.addEventListener('CookiebotOnConsentReady', updateVisibility)

    // @ts-ignore
    if (typeof Cookiebot !== 'undefined') {
      updateVisibility()
    }

    return () => {
      window.removeEventListener('CookiebotOnLoad', () => {
        /* noop (different ref) */
      })
      window.removeEventListener('CookiebotOnAccept', () => {
        /* noop (different ref) */
      })
      window.removeEventListener('CookiebotOnConsentReady', updateVisibility)
    }
  }, [])

  React.useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return
    if (!canShowSearch) return

    // @ts-ignore
    if (typeof Cookiebot !== 'undefined' && Cookiebot.consent && Cookiebot.consent.marketing) {
      const EXISTING_ID = 'google-cse-loader'
      const CONTAINER_ID = 'gcse-search'

      function renderSearch() {
        const container = document.getElementById(CONTAINER_ID)
        // @ts-ignore
        const api =
          window.google &&
          window.google.search &&
          window.google.search.cse &&
          window.google.search.cse.element
        if (!container || !api) return
        container.innerHTML = ''
        api.render({div: CONTAINER_ID, tag: 'search', gname: 'mainSearch'})
      }

      // @ts-ignore
      window.__gcse = {
        parsetags: 'explicit',
        callback: function () {
          renderSearch()
        }
      }

      if (!document.getElementById(EXISTING_ID)) {
        ;(function () {
          var cx = '402d2cd20ab5944c8'
          var gcse = document.createElement('script')
          gcse.id = EXISTING_ID
          gcse.type = 'text/javascript'
          gcse.async = true
          gcse.src = 'https://cse.google.com/cse.js?cx=' + cx
          gcse.onload = function () {
            renderSearch()
          }
          var s = document.getElementsByTagName('script')[0]
          s.parentNode!.insertBefore(gcse, s)
        })()
      } else {
        // @ts-ignore
        if (
          window.google &&
          window.google.search &&
          window.google.search.cse &&
          window.google.search.cse.element
        ) {
          renderSearch()
        } else {
          var iv = window.setInterval(function () {
            // @ts-ignore
            if (
              window.google &&
              window.google.search &&
              window.google.search.cse &&
              window.google.search.cse.element
            ) {
              window.clearInterval(iv)
              renderSearch()
            }
          }, 50)
          window.setTimeout(function () {
            window.clearInterval(iv)
          }, 3000)
        }
      }
    }
  }, [recheckCookie, canShowSearch])

  return (
    <main>
      <ModGridRow>
        {[
          {
            columnWidth: 2,
            component: (
              <div key="content" className="search-content">
                <div className="cookieconsent-optout-marketing">
                  <div className="cookieconsent-optout-marketing-custom">
                    <p>
                      <FormattedMessage
                        id={'searchCookie.acceptCookiesText1'}
                        defaultMessage={'Bitte'}
                      />{' '}
                      <button
                        type="button"
                        onClick={() => {
                          // @ts-ignore
                          if (typeof Cookiebot !== 'undefined' && Cookiebot.renew) Cookiebot.renew()
                        }}
                        style={{all: 'unset', textDecoration: 'underline', cursor: 'pointer'}}>
                        <FormattedMessage
                          id={'searchCookie.acceptCookiesLink'}
                          defaultMessage={'akzeptieren Sie die Marketing Cookies'}
                        />
                      </button>{' '}
                      <FormattedMessage
                        id={'searchCookie.acceptCookiesText2'}
                        defaultMessage={'um die Suche zu benutzen.'}
                      />
                    </p>
                  </div>
                </div>

                {canShowSearch && <div id="gcse-search"></div>}
              </div>
            )
          },
          {
            columnWidth: 1,
            component: <div></div>
          }
        ]}
      </ModGridRow>
    </main>
  )
}
